"use client";

import ReactECharts from "echarts-for-react";
import { useMemo } from "react";

interface Props { data?: object[]; slug: string }
export const TrendsLineChart = ({ data, slug }: Props) => {
  const option = useMemo(() => {
    const years = (data || []).map((row: any) => ({
      year: String(row.year),
      values: Object.fromEntries(Object.entries(row[slug] || {})
        .filter(([date, value]) => /^\d{4}-\d{2}-\d{2}$/.test(date) && value !== null && value !== "" && Number.isFinite(Number(value)))
        .map(([date, value]) => [date.slice(5), Number(value)])),
    })).filter(row => Object.keys(row.values).length).sort((a, b) => a.year.localeCompare(b.year));
    if (!years.length) return null;
    const dates = [...new Set(years.flatMap(row => Object.keys(row.values)))].sort();
    return {
      title: { text: `Tren sektor ${slug}`, textStyle: { color: "#004AAB", fontSize: 16 } },
      legend: { top: 32, data: years.map(row => row.year) },
      tooltip: { trigger: "axis" },
      grid: { top: 75, left: 10, right: 15, bottom: 35, containLabel: true },
      toolbox: { feature: { saveAsImage: {} } },
      yAxis: { type: "value", scale: true },
      xAxis: { type: "category", data: dates, boundaryGap: false },
      series: years.map(row => ({
        name: row.year, type: "line", showSymbol: false,
        data: dates.map(date => row.values[date] ?? null), connectNulls: false,
      })),
    };
  }, [data, slug]);
  if (!option) return <div className="flex h-80 items-center justify-center text-sm text-muted-foreground">Data timeseries belum tersedia untuk sektor ini.</div>;
  return <ReactECharts style={{ height: "20rem" }} option={option} notMerge />;
};
